import { createFileRoute } from "@tanstack/react-router";
import { Companies } from "@/components/Companies";

function RouteComponent() {
  return <Companies />;
}

export const Route = createFileRoute("/_authenticated/companies/")({
  component: RouteComponent,
  staticData: { page: ["companies", "valuations"] },
});
